"use client";

import type React from "react";
import { useEffect } from "react";
import { sendError } from "../components/ErrorBoundary/helpers";

type Props = {
    error: Error;
};

const Error: React.FC<Props> = ({ error }: Props) => {
    useEffect(() => {
        sendError(error);
    }, [error]);

    return (
        <html lang="de">
            <body>
                <div>error occurred</div>
            </body>
        </html>
    );
};

export default Error;
